define('common/views/dashboard_layout',['require','exports','module','base/layout','services/auth/trial','./header_view_mdheader','./footer_view_mdfooter','./sidebar_view_mdsidebar','./notice_view_mdnotice','./reminders_view_mdreminders','./trial_view','./loading_view','./error_view','./download_view','lib/util','ThemesHelper','services/auth/info','ldsh!../templates/dashboard_layout'],function (require, exports, module) {
  'use strict';

  var Layout = require('base/layout');
  var AuthTrial = require('services/auth/trial'),
    authTrial = new AuthTrial(),
    HeaderViewMDHeader = require('./header_view_mdheader'),
    FooterViewMDFooter = require('./footer_view_mdfooter'),
    SidebarViewMDSidebar = require('./sidebar_view_mdsidebar'),
    NoticeViewMDNotice = require('./notice_view_mdnotice'),
    RemindersViewMDReminders = require('./reminders_view_mdreminders'),
    TrialView = require('./trial_view'),
    LoadingView = require('./loading_view'),
    ErrorView = require('./error_view'),
    DownloadView = require('./download_view'),
    util = require('lib/util'),
    ThemesHelper = require('ThemesHelper'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo();

  module.exports = Layout.extend({
    template: require('ldsh!../templates/dashboard_layout'),
    regions: {
      content: '.js-content',
      search: '.js-search',
      top: '.js-top-content',
      header: '.js-header',
      mdSidebar: '.js-mdSidebar',
      mdNotice: '.js-mdNotice',
      expire: '.js-expire',
      download: '.js-download',
      footer: '.js-footer',
      reminders: '.js-reminders',
    },

    initialize: function () {
      this.regions.header.show(new HeaderViewMDHeader());
      this.regions.download.show(new DownloadView());
      this.regions.footer.show(new FooterViewMDFooter());
      this.regions.mdSidebar.show(new SidebarViewMDSidebar());
      this.regions.mdNotice.show(new NoticeViewMDNotice());
      if (authInfo.isAdminFreemium()) {
        this.regions.reminders.show(new RemindersViewMDReminders());
      }

      authTrial.onExpiration(_.bind(this.showTrial, this));
    },

    helpers: function () {
      var data = {
        showAMPByCompany: util.showAMPByCompany(),
        globalAssetsURL: ThemesHelper.getCurrentThemeGlobalURL(),
        hideTitle: this.options.hideTitle,
      };

      return data;
    },

    showLoading: function () {
      this.regions.content.show(new LoadingView());
    },

    showError: function () {
      this.regions.content.show(new ErrorView());
    },

    showTrial: function () {
      this.regions.expire.show(new TrialView());
    },

    onRender: function () {
      this.$el.i18n();
    },
  });
});

